import api from "./axios";

class ServiceSiagro {
  async generate(startDate, endDate) {
    const { data } = await api.post(`/siagro`, { startDate, endDate })

    return data
  }

  async verify() {
    const { data } = await api.get(`/siagro/verify`)

    return data
  }
}

export default new ServiceSiagro()
